var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-contacts-root tw-relative tw-z-[1] md:tw-col-span-2 lg:tw-col-span-3 tw-font-lato tw-text-[var(--my-text-color)] tw-leading-[var(--my-leading)]"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),_c('my-add-contact-popup'),_c('my-social-share-popup'),_c('my-import-contacts-popup')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }